// Support Card Component
import React from "react";
import {useCurrentLocale} from "widget-shared-components-library/dist";

const SupportCard = ({title, description, link}) => {
    const lang = useCurrentLocale();

    return (
        <div className="support-card">
            <div className="icon-container">
                <a href={link}>
                    <img
                        src="https://www.cosmote.gr/images/search/support.svg"
                        alt="article icon"
                        className="icon"
                    />
                </a>
            </div>
            <div className="text-container">
                <h3 className="title">{title}</h3>
                <p className="description">{description}</p>
                <a href={link} className="more-link">{lang === 'en' ? 'View more' : 'Περισσότερα'}</a>
            </div>
        </div>
    );
};

export default SupportCard;